<template>
  <!-- one bet in the phone table's drop-down: our %, the best odds and whether it's a value pick -->
  <div class="flex items-center py-1.5 tabular-nums text-[13px]" :title="price && !locked ? title : null">
    <span class="flex-1 min-w-0 truncate text-gray-600">{{ label }}</span>
    <template v-if="price && locked">
      <span class="w-[52px] flex-none text-center blur-sm select-none text-gray-500" aria-label="Members only">??</span>
      <span class="w-[52px] flex-none text-center blur-sm select-none text-gray-500" aria-label="Members only">??</span>
      <span class="w-[70px] flex-none text-center blur-sm select-none text-gray-500" aria-label="Members only">??</span>
    </template>
    <template v-else-if="price">
      <span class="w-[52px] flex-none text-center font-semibold text-gray-800">{{ Math.round(price.p) }}%</span>
      <span class="w-[52px] flex-none text-center" :class="value ? 'text-[#16a34a] font-semibold' : 'text-gray-700'">{{
        price.odds ? format(price.odds) : "–"
      }}</span>
      <span class="w-[70px] flex-none text-center">
        <span v-if="edge !== null" class="chip" :class="value ? 'value' : 'neutral'"
          >{{ value ? "Yes" : "No" }} {{ formatEdge(edge * 100) }}</span
        >
        <span v-else class="text-gray-400">–</span>
      </span>
    </template>
    <template v-else>
      <span class="w-[174px] flex-none text-center text-gray-400">–</span>
    </template>
    <span class="w-[26px] flex-none flex justify-end">
      <AddPill v-if="price" :selection="selection" />
    </span>
  </div>
</template>

<script>
import PropCell from "./PropCell.vue";

export default {
  name: "PropRow",
  extends: PropCell,
  props: {
    label: { type: String, required: true },
  },
};
</script>
